import { contractApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
export const contractApiWithTags = contractApi.enhanceEndpoints({
  endpoints: {
    // ---- Contract Revisions ----
    getContractRevisionByUserId: { providesTags: ['Contract'] },
    getContractRevision: { providesTags: ['Contract'] },
    createContractRevision: { invalidatesTags: ['Contract'] },
    acceptContractRevision: { invalidatesTags: ['Contract'] },
    revisionContract: { invalidatesTags: ['Contract'] },
    rejectContractRevision: { invalidatesTags: ['Contract'] },

    // ---- Contract Features ----
    addFeature: { invalidatesTags: ['Contract'] },
    removeFeature: { invalidatesTags: ['Contract'] },

    // ---- Contract Members ----
    addInvitedMember: { invalidatesTags: ['Contract'] },
    confirmMember: { invalidatesTags: ['Contract'] },
    rejectContract: { invalidatesTags: ['Contract'] },

    // ---- Contract CRUD ----
    getContractByInviteCode: { providesTags: ['Contract'] },
    getContractByPhonenumber: { providesTags: ['Contract'] },
    getContractByUserId: { providesTags: ['Contract'] },
    getContract: { providesTags: ['Contract'] },
    getContractStatus: { providesTags: ['Contract'] },
    deleteContract: { invalidatesTags: ['Contract'] },
    generateContractPdf: { providesTags: ['Contract'] },
    createContract: { invalidatesTags: ['Contract'] },

    // ---- KYC ----
    updateUserKycConfirmation: { invalidatesTags: ['Contract'] },

    // ---- Personal Info ----
    updatePersonalInfo: { invalidatesTags: ['Contract'] },

    // ---- Contract Info ----
    updateContractInfo: { invalidatesTags: ['Contract'] },
    getContractInfo: { providesTags: ['Contract'] },
    deleteContractInfo: { invalidatesTags: ['Contract'] },
    addContractInfo: { invalidatesTags: ['Contract'] },

    // ---- Contract Address ----
    getContractAddress: { providesTags: ['Contract'] },
    addContractAddress: { invalidatesTags: ['Contract'] },

    // ---- Manuel Payment ----
    approveManuelPayment: { invalidatesTags: ['ManuelPayment', 'Contract'] },
    rejectManuelPayment: { invalidatesTags: ['ManuelPayment', 'Contract'] },
    getManuelPaymentById: { providesTags: ['ManuelPayment'] },
    getManuelPaymentByUserId: { providesTags: ['ManuelPayment'] },
    createManuelPayment: {
      invalidatesTags: ['ManuelPayment', 'Contract', 'PayPlan'],
    },

    // ---- Interim Payments ----
    getInterimPaymentsByUserId: { providesTags: ['InterimPayment'] },
    getInterimPayment: { providesTags: ['InterimPayment'] },
    createInterimPayment: {
      invalidatesTags: ['InterimPayment', 'Contract', 'PayPlan'],
    },

    // ---- Pay Plans ----
    getPayPlansByContractId: { providesTags: ['PayPlan'] },
    getPayPlansByUserId: { providesTags: ['PayPlan'] },
    getPayPlan: { providesTags: ['PayPlan'] },
    // Erkeğin pay plan'ı oluşunca kadın tarafındaki contribution-info da
    // geçerli hâle geldiği için ContributionInfo tag'i de invalidate edilir.
    createPayPlan: {
      invalidatesTags: ['PayPlan', 'Contract', 'ContributionInfo'],
    },
    updatePayPlan: {
      invalidatesTags: ['PayPlan', 'Contract', 'ContributionInfo'],
    },
    deletePayPlan: {
      invalidatesTags: ['PayPlan', 'Contract', 'ContributionInfo'],
    },

    // ---- Savings Plans (BES / birikim planı) ----
    // getContributionInfo: kadın tarafında oluşturma-öncesi ekran; erkeğin
    // pay plan'ından türetilen miktar/gün/tarih bilgisini verir.
    getContributionInfo: { providesTags: ['ContributionInfo'] },
    listSavingsPlans: { providesTags: ['SavingsPlan'] },
    getSavingsPlan: { providesTags: ['SavingsPlan'] },
    getTransactions: { providesTags: ['SavingsPlan'] },
    // createSavingsPlan backend'de BES poliçesini tetikler → BesPolicy da
    // invalidate edilir ki getByContractId oluşan poliçeyi çeksin.
    createSavingsPlan: { invalidatesTags: ['SavingsPlan', 'BesPolicy'] },
    updateAllocations: { invalidatesTags: ['SavingsPlan', 'BesPolicy'] },
    pausePlan: { invalidatesTags: ['SavingsPlan'] },
    resumePlan: { invalidatesTags: ['SavingsPlan'] },

    // ---- Transactions ----
    getTransactionsByContractId: { providesTags: ['Transaction'] },
    getTransactionsByUserId: { providesTags: ['Transaction'] },
    getTransactionById: { providesTags: ['Transaction'] },
    createTransaction: {
      invalidatesTags: ['Transaction', 'Contract', 'PayPlan'],
    },
    deleteTransaction: {
      invalidatesTags: ['Transaction', 'Contract', 'PayPlan'],
    },

    // ---- Main Types ----
    getAllMainTypes: { providesTags: ['MainType'] },
  },
});
